import { Base64 } from 'js-base64';

import useSearchParams from './useSearchParams';

export default function useHelloBraveCookiesSearchParams(location: Location) {
  const [searchParams] = useSearchParams(location);
  const { m, n } = searchParams;
  const mid = decode(m);
  const nickname = decode(n);
  return { mid, nickname };
}

function decode(b64str: any): string {
  if (!b64str) return '';
  try {
    return Base64.decode(b64str + '');
  } catch (e) {
    console.error(e.stack);
    return '';
  }
}
